<template>
  <div class="search-mod">
      <input type="text" placeholder="输入关键字搜索" v-model="searchString">
      <button @click="submit">
          <i class="el-icon-search"></i>
      </button>
  </div>
</template>

<script>
export default {
    data(){
        return{
            searchString:''
        }
    },
    methods:{
        submit(){
            this.$router.push('/search/'+this.searchString)
        }
    }
}
</script>

<style lang="scss">
.search-mod{
    // border-radius: 20px;
    // background-color: #e2f6fe;
    // width: 225px;
    // height: 46px;
    // line-height: 46px;
    // box-sizing: border-box;
    // color: #125871;
    // font-size: 14px;
    input{
        height: 38px;
        border: 1px solid #91d1ff;
        outline: none;
        padding-left: 12px;
        width: 180px;
        box-sizing: border-box;
           color: $primary;
        &::placeholder{
              color: #bbe3ff;
            }
    }
    button{
        height:38px;
         background-color: #e2f6fe;
          padding: 0 12px;
          border: none;
            color: $primary;
        &:hover{
            cursor: pointer;
        }

    }
}
</style>
